(function($){

	var $doc = $(document),
		$win = $(window),
		winHeight = null,
		touch = false;

	//document ready
	$doc.on('ready', function(){

		if($('html').is('.touch')){
			touch = true;
		}

		$doc

		//blink fields
		.on('focusin', '.field, textarea', function() {
			if(this.title==this.value) {
				this.value = '';
			}
		}).on('focusout', '.field, textarea', function(){
			if(this.value=='') {
				this.value = this.title;
			}
		});

		sectionResize();

		$('.section').each(function(){
			$(this).css('z-index', $(this).index());
		});
		$('.section.last').css('z-index', $('.section.last').prev('.section').css('z-index') - 1);

		$('.slideshow ul').carouFredSel({
			scroll:{
				fx:'crossfade'
			}

		});

		$('.contact-form form').on('submit', function(){
			$(this).hide().siblings('.thanks').fadeIn();
			return false; //remove this line to make the form works
		});

		$('#navigation ul a').on('click', function(){
			var navHref = $(this).attr('href'),
				scrollPos = 0;

			if(touch){
				scrollPos = $(navHref).offset().top;
			}else{

				if(navHref == '#intro'){
					scrollPos = $(navHref).data('height');
				}else{
					scrollPos = $(navHref).data('height');
					$(navHref).prevAll('.section').each(function(){
						scrollPos = scrollPos + $(this).data('height');
					});
				}
			}
			if(!$('body').is('.animating')){
				$('body').addClass('animating');
				$('html, body').animate({'scrollTop': scrollPos}, 2500, function(){
					$('body').removeClass('animating');
				});
			}

			return false;
		});

		if(touch){
			$('.section.last').remove();
		}

		$('.next-section').on('click', function(){
			$('#navigation li.active').next('li').find('a').click();
			return false;
		});


		/*=================*/
		/*=== Animation ===*/
		if(!touch){
			var controller = $.superscrollorama(),
				animSpeed = winHeight,
				aOpBefore = { css: {opacity:0}, immediateRender:true },
				aOpAfter = { css: {opacity:1} },
				aTextBefore = {
					css: {opacity:0, textShadow:'0 0 8px', color:'transparent'},
					immediateRender:true
				},
				aWhiteTextAfter = {
					css: {opacity:1, color:'#fff', textShadow:'0 -1px rgba(0,0,0,0.6)'}
				},
				aBlueTextAfter = {
					css: {opacity:1, color:'#7a7ebb', textShadow:'none'}
				},
				aBlackTextAfter = {
					css: {opacity:1, color:'#808080', textShadow:'none'}
				},
				aBtnBefore = {
					css: {opacity:0, boxShadow:'0 0 20px #7a7ebb', textShadow:'0 0 8px #fff'},
					immediateRender:true
				},
				aBtnAfter = {
					css: {opacity:1, boxShadow:'inset 0 -1px #5b5e8c;', textShadow:'none'}
				};

			if($.browser.msie){
				aTextBefore = {
					css: {opacity:0, textShadow:'0 0 8px'},
					immediateRender:true
				}
			}

			//indivudial animation for each section
			var aIntro = {
					anim: (new TimelineLite())

					//animate the heading
					.append(
						TweenMax.fromTo($('#intro h2'), 25,
							{css:{opacity:0}, immediateRender:true},
							{css:{opacity:1}}	
						)
					)

					//animate the paragraph
					.append(
						TweenMax.fromTo($('#intro p'), 25,
							{css:{opacity:0}, immediateRender:true},
							{css:{opacity:1}}	
						)
					)

					//animate the button
					.append(
						TweenMax.fromTo($('#intro .btn'), 25,
							{css:{opacity:0}, immediateRender:true},
							{css:{opacity:1}}	
						)
					)

					//make the content fixed, so the bottom section overlap current
					.append(
						TweenMax.to($('#intro .content'), 25,
							{css:{position: 'fixed', top:0}}
						)
					)

				},
				aProducts = {
					anim: (new TimelineLite())

					//animate the slippers
					.append(
						TweenMax.fromTo($('.ribbon.slippers'), 20,
							{css:{top:-435}, immediateRender:true},
							{css:{top:0}}
						)
					)
					//animate the heading
					.append(
						TweenMax.fromTo($('#products h2'), 20, aTextBefore, aWhiteTextAfter)
					)

					//animate the paragraph
					.append(
						TweenMax.fromTo($('#products p'), 20, aTextBefore, aWhiteTextAfter)
					)

					//animate the button
					.append(
						TweenMax.fromTo($('#products .btn'), 20, aBtnBefore, aBtnAfter)
					)

					//make the content fixed, so the bottom section overlap current
					.append(
						TweenMax.to($('#products .content'), 20,
							{css:{position: 'fixed', top:0}}
						)
					)
				},
				aPartners = {
					anim: (new TimelineLite())

					//animate the heading
					.append(
						TweenMax.fromTo($('#partners h2'), 20, aTextBefore, aBlueTextAfter)
					)

					//animate the paragraph and owl
					.append([
						TweenMax.fromTo($('#partners p'), 20, aTextBefore, aBlackTextAfter),
						TweenMax.fromTo($('.ribbon.owl'), 20,
							{css:{right:'100%', opacity:0}, immediateRender:true},
							{css:{right:-330, opacity:1}}
						)
					])

					//animate the partners
					.append(TweenMax.fromTo($('.partners-list'), 4, aOpBefore, aOpAfter))
					.append(TweenMax.fromTo($('.partners-list li:nth(0)'), 2, aOpBefore, aOpAfter))
					.append(TweenMax.fromTo($('.partners-list li:nth(1)'), 2, aOpBefore, aOpAfter))
					.append(TweenMax.fromTo($('.partners-list li:nth(2)'), 2, aOpBefore, aOpAfter))
					.append(TweenMax.fromTo($('.partners-list li:nth(3)'), 2, aOpBefore, aOpAfter))
					.append(TweenMax.fromTo($('.partners-list li:nth(4)'), 2, aOpBefore, aOpAfter))
					.append(TweenMax.fromTo($('.partners-list li:nth(5)'), 2, aOpBefore, aOpAfter))
					.append(TweenMax.fromTo($('.partners-list li:nth(6)'), 2, aOpBefore, aOpAfter))
					.append(TweenMax.fromTo($('.partners-list li:nth(7)'), 2, aOpBefore, aOpAfter))

					//animate the button
					.append(
						TweenMax.fromTo($('#partners .btn'), 20, aBtnBefore, aBtnAfter)
					)

					//make the content fixed, so the bottom section overlap current
					.append(
						TweenMax.to($('#partners .content'), 20,
							{css:{position: 'fixed', top:0}}
						)
					)

				},
				aJoinUs = {
					anim: (new TimelineLite())

					//animate the heading
					.append(
						TweenMax.fromTo($('#join-us h2'), 20, aTextBefore, aWhiteTextAfter)
					)

					//animate the paragraph
					.append(
						TweenMax.fromTo($('#join-us p'), 20, aTextBefore, aWhiteTextAfter)
					)

					//animate the button
					.append(
						TweenMax.fromTo($('#join-us .btn'), 20, aBtnBefore, aBtnAfter)
					)

					//animate the slideshow
					.append(
						TweenMax.fromTo($('.slideshow'), 20,
							{css:{left:'-100%'}, immediateRender:true},
							{css:{left:0}}
						)
					)

					//make the content fixed, so the bottom section overlap current
					.append(
						TweenMax.to($('#join-us .content'), 20,
							{css:{position: 'fixed', top:0}}
						)
					)
				},
				aContact = {
					anim: (new TimelineLite())

					//animate the form
					.append(
						TweenMax.fromTo($('.contact-form'), 99,
							{css:{top:-1000}, immediateRender:true},
							{css:{top:0}}
						)
					)

					//make the content fixed, so the bottom section overlap current
					.append(
						TweenMax.to($('#contact .content'), 20,
							{css:{position: 'fixed', top:0}}
						)
					)
				};


			controller.pin('#intro', animSpeed * $('#intro').data('height-multiply'), aIntro);
			controller.pin('#products', animSpeed * $('#products').data('height-multiply'), aProducts);
			controller.pin('#partners', animSpeed * $('#partners').data('height-multiply'), aPartners);
			controller.pin('#join-us', animSpeed * $('#join-us').data('height-multiply'), aJoinUs);
			controller.pin('#contact', animSpeed * $('#contact').data('height-multiply'), aContact);
		}

	});//document ready

	$win.on('resize', function(){
		sectionResize();
	});

	$win.on('scroll', function(){
		scroller($('.section'), $('#navigation'));
	});

	$win.on('load', function(){
		if(!touch){
			$('#navigation li.home a').click();
		}
		scroller($('.section'), $('#navigation'));
	});

	function sectionResize(){
		winHeight = $win.height();
		$('.section').css('min-height', winHeight);
		
		$('.section').each(function(){
			var $section = $(this),
				$cnt = $section.find('.content').css('min-height', 0);
			
			if($cnt.height() < winHeight){
				var padding_ = (winHeight - $cnt.height())/2;
				$cnt.css({'padding-top': padding_, 'min-height': winHeight - padding_});
				
				if(!touch){
					$section.attr('data-height', $win.height()*($section.data('height-multiply') + 1 ))
		
					if($section.is('#intro')){
						$section.attr('data-height', $win.height()*($section.data('height-multiply')))
					}
					if($section.is('#contact')){
						$section.attr('data-height', $win.height()*($section.data('height-multiply') + 2))
					}
						
				}else{
					$section.attr('data-offset', $section.offset().top);
				}
				if($section.is('#contact')){
					$cnt.css({'padding-top': 20, 'min-height': winHeight - 20})
				}

			}
		});
	}

	function scroller($section, $nav){
		var $curSect = $section.filter(function(){
				if($(this).offset().top <= ($win.scrollTop())){
					return $(this);
				}
			}).last(),
			curSectID = $curSect.attr('id');

		if(!$curSect.is('.active')){
			$curSect.addClass('active').siblings($section).removeClass('active');
			$nav.find('a[href="#'+curSectID+'"]').closest('li').addClass('active').siblings('li').removeClass('active');
		}
	}



})(jQuery)